module.exports = __webpack_public_path__ + "img/tooltip_caldera-4.d8e9d5ef.jpg";